import { getField, updateField } from "vuex-map-fields";
import API from "@/api";

const initialState = () => ({});

export const state = initialState();

export const getters = {
  getField,
};

export const actions = {
  async get({ state, dispatch, commit }) {
    const response = await API.axios.get("/bff/api/v1/paineis/allowed");
    // console.log(response);
    return response;
  },

  async getDashboardURL({ state, dispatch, commit }, { id }) {
    const response = await API.axios.get(`/bff/api/v1/paineis/url/${id}`);
    // console.log(response);
    return response;
  },
};

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
